import React from 'react';
import Banner from './Banner';
import Enrollment from './Enrollment';

const Academy = ({ title }) => {
    return (
        <div className='mt-10 py-5' id='maya'>
            <h3 className=' text-slate-400 font-bold lg:text-3xl text-2xl pb-1 border-b-2 border-cyan-600 mb-6'>{title}</h3>

            <div className='grid md:grid-cols-[20%_minmax(60%,_1fr)_20%] grid-cols-1 w-full'>
                <Enrollment></Enrollment>
                <Banner maya></Banner>
                <div className='px-5'>
                    <h4 className='bg-head text-white text-center text-lg rounded-sm p-2'>Offers</h4>
                    <div className=' text-xl font-semibold text-center py-5 md:py-2 text-slate-500 bg-neutral-100 my-3 rounded'>
                        <span className='text-2xl text-red-700 font-bold'>Free</span> <br /> Japanese Courses*
                    </div>
                    <div className=' text-xl font-semibold text-center py-5 md:py-2 text-slate-500 bg-neutral-100 my-3 rounded'>
                        <span className=' text-red-700 text-2xl font-bold'>Free</span> <br /> Your Life Support in Japan
                    </div>
                    {/* <div className='mx-auto w-full flex justify-center mt-4'>
                        <a href="#enroll">
                            <button type="submit" className='w-full py-2 px-3 text-center bg-sky-600 rounded text-white mx-auto'>Enroll Now</button></a>
                    </div> */}
                </div>
            </div>

        </div>
    );
};

export default Academy;